class NavDropdown extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController()
    this.summary = this.querySelector('summary')
    this.detail = this.querySelector('details')

    if (this.detail.dataset.hover === 'true') this.hoverMenu()
    this.menuDetailsHandler()
  }

  close() {
    if (!this.detail.hasAttribute('open')) return
    this.detail.removeAttribute('open')
    this.detail.setAttribute('aria-expanded', 'false')
    this.summary.setAttribute('aria-expanded', 'false')
  }

  menuDetailsHandler() {
    document.addEventListener(
      'click',
      (evt) => {
        if (!this.detail.hasAttribute('open')) return

        // Anywhere outside this dropdown closes it.
        if (!this.contains(evt.target)) {
          this.close()
          return
        }

        // Inside it, anything the shopper can act on closes it too: a nested
        // option, a link, a button. The summary is excluded because that is
        // the control that opens and closes the dropdown itself.
        const actionable = evt.target.closest('a, button, [role="button"], input, label')
        if (actionable && !this.summary.contains(evt.target)) {
          this.close()
        }
      },
      { signal: this.abortController.signal }
    )

    // Escape closes it wherever focus happens to be, not only in hover mode.
    document.addEventListener(
      'keydown',
      (evt) => {
        if (evt.key === 'Escape' && this.detail.hasAttribute('open')) {
          this.close()
          this.summary.focus()
        }
      },
      { signal: this.abortController.signal }
    )

    // Opening one dropdown closes any other, so two menus cannot sit open
    // over each other.
    this.detail.addEventListener(
      'toggle',
      () => {
        if (!this.detail.open) {
          this.summary.setAttribute('aria-expanded', 'false')
          return
        }
        this.summary.setAttribute('aria-expanded', 'true')
        document.querySelectorAll('nav-dropdown').forEach((other) => {
          if (other !== this && typeof other.close === 'function') other.close()
        })
      },
      { signal: this.abortController.signal }
    )
  }

  hoverMenu() {
    const summaryLink = this.summary.dataset.link

    this.summary.addEventListener(
      'click',
      (e) => {
        e.preventDefault()

        if (!this.detail.hasAttribute('open')) {
          this.detail.setAttribute('open', '')
          this.detail.setAttribute('aria-expanded', 'true')
        } else {
          window.location.href = summaryLink
        }
      },
      { signal: this.abortController.signal }
    )

    this.detail.addEventListener(
      'focusout',
      (e) => {
        const isChild = this.detail.contains(e.relatedTarget)

        if (!isChild) {
          this.detail.removeAttribute('open')
          this.detail.setAttribute('aria-expanded', 'false')
        }
      },
      { signal: this.abortController.signal }
    )

    this.detail.addEventListener(
      'keydown',
      (e) => {
        if (e.key === 'Escape' && this.detail.hasAttribute('open')) {
          this.detail.removeAttribute('open')
          this.detail.setAttribute('aria-expanded', 'false')
          this.summary.focus()
        }
      },
      { signal: this.abortController.signal }
    )

    this.detail.addEventListener(
      'mouseover',
      () => {
        if (!this.detail.hasAttribute('open')) {
          this.detail.setAttribute('open', '')
          this.detail.setAttribute('aria-expanded', 'true')
        }
      },
      { signal: this.abortController.signal }
    )

    this.detail.addEventListener(
      'mouseleave',
      () => {
        if (this.detail.hasAttribute('open')) {
          this.detail.removeAttribute('open')
          this.detail.setAttribute('aria-expanded', 'false')
        }
      },
      { signal: this.abortController.signal }
    )
  }

  disconnectedCallback() {
    this.abortController.abort()
  }
}

customElements.define('nav-dropdown', NavDropdown)
